import React, { useMemo } from 'react'
import { Box } from '@maui/elements'

const formatReports = (data) => {
  return {
    ...data,
    name: data.title,
    date: data.publish_date,
    reportType: data.report_type || data.reportType,
    reportId: data.report_id || data.report_id,
    description: data.executive_summary || data.isightComment,
    tags: data.tags
      ? Object.entries(data.tags).map(tag => {
        return {
          name: tag[0],
          values: tag[1]
        }
      })
      : []
  }
}

export const ReportSearchPreview = ({ data }) => {
  const formattedData = useMemo(() => {
    if (!data) return
    return formatReports(data)
  }, [data])

  const {
    name
  } = formattedData

  return (
    <Box>
      {name}
    </Box>
  )
}
